import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const CaptchaContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  paddingLeft: '5px',
});
